import React from 'react';
import { connect } from 'react-redux';
import { Redirect, withRouter } from 'react-router-dom';
import Loading from '../components/loading';
import DependentForm from '../components/dependentForm';
import Footer from '../components/footer';
import UserCard from '../components/usercard';
import NavBar from '../components/navbar';
import TermsOfUseLink from '../components/termsOfUseLink';

class DependentRegScreen extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
        }
    }

    componentDidMount(){
    }

    render() {
        if (this.props.isError === true) {
            return <Redirect to="error" />
        }
        if (this.props.isLoggedIn !== true && this.props.isFakeLoggedIn !== true && this.props.isLoggingOut!==true) {
            return <Redirect to="/" />
        }
        if (this.props.isLoadingLogin === true || this.props.isLoadingLabResults === true || this.props.isLoggingOut ===true){
                return <Loading />
        }

        return (
            <div className="container-full">
                <NavBar language={this.props.language}/>
                <div className="container">
                    <div className="col-12 col-lg-4 col-md-12 hideDT">
                        <UserCard user={this.props.user} language={this.props.language}/>
                    </div>
                    <div className="regInfo hideDT">
                      <h5>{this.props.strings.REG_INFO_LABLE}</h5>
                      <p>{this.props.strings.REG_INFO_MESSAGE_1}</p>
                      <p>{this.props.strings.REG_INFO_MESSAGE_2}</p>
                      <p>{this.props.strings.REG_INFO_MESSAGE_3}</p>
                    </div>
                    <div className="row">
                        <div className="col-12 col-lg-8 col-md-12 order-lg-1 order-md-2">
                            <DependentForm />
                        </div>
                        <div className="col-12 col-lg-4 col-md-12 order-2 order-sm-1 order-md-1 ml-auto ml-md-auto">
                            <div className="hideMobile">
                                <UserCard user={this.props.user} language={this.props.language} />
                                <TermsOfUseLink />
                            </div>
                            <br/>
                            <div className="regInfo hideMobile">
                                <h5>{this.props.strings.REG_INFO_LABLE}</h5>
                                <p>{this.props.strings.REG_INFO_MESSAGE_1}</p>
                                <p>{this.props.strings.REG_INFO_MESSAGE_2}</p>
                                <p>{this.props.strings.REG_INFO_MESSAGE_3}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        isLoadingLabResults: state.api.isLoadingLabResults,
        isLoadingUsers: state.api.isLoadingUsers,
        user: state.api.user,
        labResults: state.api.labResults,
        strings: state.language.strings,
        language: state.language.language,
        isLoggedIn: state.auth.isLoggedIn,
        isFakeLoggedIn: state.auth.isFakeLoggedIn,
        isError: state.api.isError,
        isLoggingOut: state.auth.isLoggingOut,
    }
}

const ConnectedDependentRegScreen = connect(
    mapStateToProps
)(DependentRegScreen);

export default withRouter(ConnectedDependentRegScreen);
